import { NgModule } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { TabsModule } from 'primeng/tabs';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MAccordionComponent } from '@design-system/components/m-accordion/m-accordion.component';
import { MAccordionPanelComponent } from '@design-system/components/m-accordion-panel/m-accordion-panel.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    TableModule,
    MenubarModule,
    StyleClassModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputNumberModule,
    ProgressSpinnerModule,
    DialogModule,
    CardModule,
    MultiSelectModule,
    DatePickerModule,
    SelectModule,
    InputSwitchModule,
    CheckboxModule,
    MenuModule,
    BadgeModule,
    SelectButtonModule,
    OverlayPanelModule,
    MAccordionComponent,
    MAccordionPanelComponent,
    RadioButtonModule,
    RippleModule,
    BreadcrumbModule,
    AutoCompleteModule
  ],
  exports: [
    ButtonModule,
    TableModule,
    MenubarModule,
    StyleClassModule,
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputNumberModule,
    ProgressSpinnerModule,
    DialogModule,
    CardModule,
    MultiSelectModule,
    DatePickerModule,
    SelectModule,
    InputSwitchModule,
    CheckboxModule,
    MenuModule,
    BadgeModule,
    TabsModule,
    SelectButtonModule,
    OverlayPanelModule,
    MAccordionComponent,
    MAccordionPanelComponent,
    RadioButtonModule,
    RippleModule,
    BreadcrumbModule,
    AutoCompleteModule
  ]
})
export class PrimengModule {}
